import '../../assets/css/container/main/MainWrapper.css';
import {useNavigate, useLocation} from 'react-router-dom';
import {useAuth} from "../../global/AuthContext";
import WriteFactBtn from "../../component/WriteFactBtn";
import RecentFact from "../../component/factList/RecentFact";
import SearchBar from "../../component/SearchBar";
import {useState, useEffect, useRef} from 'react';

/** UI 전용 카테고리 그룹 */
/** 팩카이브 UI 전용 카테고리 그룹
 *  - 대주제: 소스/UI 전용
 *  - 소주제: 기존 DB category 개념을 세분화한 값
 */
const CATEGORY_GROUPS = {
	사회: [
		"뉴스",
		"사회",
		"문화",
		"교육",
		"직업",
		"생활",
		"연예",
	],

	정치: [
		"정치",
		"외교",
	],

	경제: [
		"경제",
		"금융",
		"산업",
		"부동산",
	],

	과학: [
		"과학",
		"기술",
	],

	의료: [
		"의료",
		"건강",
	],

	환경: [
		"환경",
		"기후",
	],

	법률: [
		"법",
		"제도",
	],

	데이터: [
		"스포츠",
		"통계",
	],

	역사: [
		"역사",
		"사건",
	],
} as const;


type CategoryGroupKey = keyof typeof CATEGORY_GROUPS;

const CATEGORY_KEYS = Object.keys(CATEGORY_GROUPS) as CategoryGroupKey[];
const ALL_CATEGORIES: string[] = Object.values(CATEGORY_GROUPS).flat();

const MainWrapper = () => {
	const navigate = useNavigate();
	const location = useLocation();
	const {user, loading} = useAuth();
	const isLoggedIn = !!user;

	const categoryAreaRef = useRef<HTMLDivElement | null>(null);

	// const [isLoggedIn, setIsLoggedIn] = useState(
	// 	!!localStorage.getItem("accessToken")
	// );
	const [isMobile, setIsMobile] = useState(
		window.innerHeight > window.innerWidth
	);

	/** 카테고리 상태 */
	const [openGroup, setOpenGroup] =
		useState<CategoryGroupKey | null>(null);
	const [selectedCategory, setSelectedCategory] =
		useState<string | null>(null);

	/** 검색 상태 */
	const [keyword, setKeyword] = useState("");
	const [searchType, setSearchType] =
		useState<"recent" | "my" | "interest">("recent");

	useEffect(() => {
		const nextType = location.state?.initialType;

		if (nextType && nextType !== searchType) {
			setSearchType(nextType);

			// 🔥 타입 바뀌면 기존 검색 조건 정리 (중요)
			setKeyword("");
			setSelectedCategory(null);
		}
	}, [location.state]);


	/* 로그인 상태 동기화 */
	// useEffect(() => {
	// 	const syncLoginState = () => {
	// 		setIsLoggedIn(!!localStorage.getItem("accessToken"));
	// 	};
	// 	window.addEventListener("storage", syncLoginState);
	// 	window.addEventListener("loginStateChanged", syncLoginState);
	// 	return () => {
	// 		window.removeEventListener("storage", syncLoginState);
	// 		window.removeEventListener("loginStateChanged", syncLoginState);
	// 	};
	// }, []);

	/* 화면 비율 감지 */
	useEffect(() => {
		const handleResize = () => {
			const ratio = window.innerHeight / window.innerWidth;

			// "진짜 세로 모바일"만 mobile
			setIsMobile(ratio >= 0.75);
		};

		handleResize(); // 초기 1회 실행
		window.addEventListener("resize", handleResize);
		return () => window.removeEventListener("resize", handleResize);
	}, []);

	/* 바깥 클릭 시 하위 카테고리 닫기 */
	useEffect(() => {
		const handleClickOutside = (e: MouseEvent) => {
			if (
				categoryAreaRef.current &&
				!categoryAreaRef.current.contains(e.target as Node)
			) {
				setOpenGroup(null);
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	/* 🔐 searchType 변경 핸들러 (⭐ 핵심) */
	const handleSearchTypeChange = (
		nextType: "recent" | "my" | "interest"
	) => {
		const loggedIn = !!localStorage.getItem("accessToken");

		if ((nextType === "my" || nextType === "interest") && !loggedIn) {
			alert("로그인이 필요한 기능입니다.");
			navigate("/login"); // 또는 "/login"
			return;
		}

		setSearchType(nextType);
	};

	/** 모바일 */
	if (isMobile) {
		return (
			<div className="MainWrapper mobile">
				<SearchBar
					value={keyword}
					onChange={(e) => setKeyword(e.target.value)}
					onSubmit={({keyword, type, category}) => {
						setKeyword(keyword);
						handleSearchTypeChange(type);
						setSelectedCategory(category);
					}}
					placeholder={
						selectedCategory
							? `${selectedCategory} 검색`
							: "Fact 검색"
					}
					type={searchType}
					onTypeChange={(e) =>
						handleSearchTypeChange(
							e.target.value as "recent" | "my" | "interest"
						)
					}
					category={selectedCategory}
					categoryList={ALL_CATEGORIES}
					onCategoryChange={(e) =>
						setSelectedCategory(e.target.value || null)
					}
				/>

				<RecentFact
					keyword={keyword}
					type={searchType}
					category={selectedCategory}
				/>

				{/*{isLoggedIn && (*/}
				{/*	<WriteFactBtn onClick={() => navigate("/writeNew")} />*/}
				{/*)}*/}
			</div>
		);
	}

	return (
		<div className="MainWrapper desktop">
			<div className="category-area">
				<div className="category-archive">
					{CATEGORY_KEYS.map((group) => (
						<div key={group} className="category-group">
							<div className="category-group-title">
								{group}
							</div>

							<div className="category-group-items">
								{CATEGORY_GROUPS[group].map((cat) => (
									<div
										key={cat}
										className={`category-item ${
											selectedCategory === cat ? "active" : ""
										}`}
										onClick={() => setSelectedCategory(cat)}
									>
										{cat}
									</div>
								))}
							</div>
						</div>
					))}
				</div>
			</div>



			<SearchBar
				value={keyword}
				onChange={(e) => setKeyword(e.target.value)}
				onSubmit={({keyword, type, category}) => {
					setKeyword(keyword);
					handleSearchTypeChange(type);
					setSelectedCategory(category);
				}}
				placeholder={
					selectedCategory
						? `${selectedCategory} 검색`
						: "Fact 검색"
				}
				type={searchType}
				onTypeChange={(e) =>
					handleSearchTypeChange(
						e.target.value as "recent" | "my" | "interest"
					)
				}
				category={selectedCategory}
				categoryList={ALL_CATEGORIES}
				onCategoryChange={(e) =>
					setSelectedCategory(e.target.value || null)
				}
			/>

			<div className="main-content-grid">
				<section className="recent-posts-section">
					<h2>
						{selectedCategory
							? `${selectedCategory} 팩트`
							: "전체 팩트"}
					</h2>

					<RecentFact
						keyword={keyword}
						type={searchType}
						category={selectedCategory}
					/>
				</section>

				<aside className="sidebar-info">
					<div className="sidebar-box">
						<h3>FactWeb</h3>
						<p className="sidebar-desc">
							사실을 검증하고<br/>
							근거로 토론하는 공간
						</p>
						<button
							className="sidebar-btn"
							onClick={() => navigate("/about")}
						>
							FactWeb 소개
						</button>
					</div>

					<div className="sidebar-box">
						<h3>공지사항</h3>
						<p className="sidebar-desc">
							업데이트 및<br/>
							운영 공지 확인
						</p>
						<button
							className="sidebar-btn"
							onClick={() => {
								if (!isLoggedIn) {
									alert("로그인이 필요한 기능입니다.");
									navigate("/login", {
										state: {redirectTo: "/notices"}
									});
									return;
								}
								navigate("/notices");
							}}
						>
							공지 보러가기
						</button>
					</div>

					<div className="sidebar-box muted">
						<p className="sidebar-hint">
							팩트에 투표하고<br/>
							긍·부정 근거를<br/>
							남겨보세요.
						</p>
					</div>
				</aside>

			</div>

			{/*{isLoggedIn && (*/}
			{/*	<WriteFactBtn onClick={() => navigate("/writeNew")} />*/}
			{/*)}*/}
		</div>
	);
};

export default MainWrapper;
